import { fork, all } from 'redux-saga/effects';
import siteComponentSagas from 'yoda-site-components/lib/sagas';

import watchAddToCartInterstitialSaga from 'yoda-checkout-components/lib/sagas/AddToCartInterstitialSaga';
import watchcartItemUpdateSaga from 'yoda-checkout-components/lib/sagas/CartItemUpdateSaga';
import watchMyListSaga from 'yoda-account-components/lib/sagas/MyListSaga';
import watchListsRequest from 'yoda-site-components/lib/sagas/ListsSaga';
import watchMyAlertsSaga from 'yoda-site-components/lib/sagas/MyAlertsSaga';
import watchAddToCartSaga from 'yoda-site-components/lib/sagas/AddToCartSaga';
import watchMTLToolTipSaga from 'yoda-site-components/lib/sagas/SavedListToolTip';
import watchPlccDynamicBannerSaga from 'yoda-site-components/lib/sagas/PlccDynamicBannerSaga';
import watchListsaga from './MyListSaga';
import watchSavedListsaga from './SavedListSaga';

const siteComponentSagaList = Object.values(siteComponentSagas.injectedSagas);
const productSagas = [
    /**
     * To display alert popup to subscribe request
     * yoda-site-components/src/components/MyAlertsSignup/MyAlertsSignup.jsx
     * yoda-site-components/src/components/StockAlertSignUpModal/StockAlertSignUpModal.jsx
     * yoda-site-components/lib/components/StockAlertSignUpModal/StockAlertSignUpModalConnect.jsx
     */
    watchMyAlertsSaga,
    /**
     * watchAddToCartInterstitialSaga used in:
     * yoda-checkout-components/src/components/AddToCartInterstitial/AddToCartInterstitial.jsx
     * src/components/Lists/AddToCart/AddToCart.jsx
     */
    watchAddToCartInterstitialSaga,
    /**
     * watchcartItemUpdateSaga used in:
     * yoda-checkout-components/src/components/AddToCartInterstitial/components/InterstitialWrapper/InterstitialWrapper.jsx
     * yoda-checkout-components/src/components/EditCartSilverItemCTA/EditCartSilverItemCTA.jsx
     */
    watchcartItemUpdateSaga,
    /**
     * watchMyListSaga used in:
     * yoda-site-components/src/components/CreateMyList/CreateMyList.jsx
     */
    watchMyListSaga,
    /**
     * watchListsaga used in:
     * GET_LIST - src/components/Lists/FilterPanel/FilterPanel.jsx
     * GET_TRENDING_LIST - src/containers/Pages/TrendingList/TrendingList.jsx
     * CREATE_LIST - src/components/Lists/CreateListDropDown/CreateListDropDown.jsx
     * DELETE_LIST - src/components/Lists/FilterPanel/FilterPanel.jsx
                   - src/components/Lists/ItemTile/ItemTile.jsx
     * SAVE_TO_LIST - src/components/Lists/FilterPanel/FilterPanel.jsx
     * LOAD_TRENDING_ITEMS - src/containers/Pages/TrendingList/TrendingList.jsx
     */
    watchListsaga,
    /**
     * watchSavedListsaga used in:
     * DELETE_SAVED_LIST - src/components/Lists/FilterPanel/FilterPanel.jsx
                         - src/components/Lists/ItemTile/ItemTile.jsx
     * GET_SAVED_LIST - src/containers/Pages/Lists/ListDetailsPanel/ListDetailsPanel.jsx
     * GET_SAVED_LIST - src/containers/Pages/Lists/ListDetailsPanel/ListDetailsPanel.jsx
     * GET_LIST_CATEGORY - src/containers/Pages/Lists/ListLandingPage.jsx
     * SHARE_LIST - src/components/MyShareSlider/MyShareSlider.jsx
     * TOGGLE_MOST_WANTED_IN_LIST - src/components/Lists/ItemTile/ItemTile.jsx
     * UPDATE_MOST_WANTED - src/components/Lists/ItemTile/ItemTile.jsx
     * DELETE_SAVED_LIST_ITEM - src/components/Lists/ItemTile/ItemTile.jsx
     */
    watchSavedListsaga,
    /**
     * watchPlccDynamicBannerSaga used by:
     * yoda-checkout-components/src/components/FreeShippingThreshold/FreeShippingThreshold.js
     */
    watchPlccDynamicBannerSaga,
    /**
     * PDP/Listing - add to list
     * yoda-microsite-listing/src/containers/Pages/Lists/ListDetailsPanel/ListDetailsPanel.jsx
     * yoda-microsite-pdp/src/components/AddToList/AddToList.jsx
     */
    watchListsRequest,
    /**
     * add to cart
     * yoda-microsite-listing/src/common/CustomAddToCart/CustomAddToCart.jsx
     * yoda-mini-pdp/src/components/MiniPDPLayout/MiniPDPLayout.jsx
     */
    watchAddToCartSaga,
    ...siteComponentSagaList,
    /**
     * add to my list
     * yoda-microsite-listing/src/components/Lists/Move/Move.jsx
     * yoda-microsite-pdp/src/components/AddToList/AddToList.jsx
     */
    watchMTLToolTipSaga,
];

const injectedSagas = {};
for (const saga of productSagas) { // eslint-disable-line
    // 1. Check that every saga has a name
    if (!saga.sagaName) {
        throw new Error(
            `Every saga has to have sagaName property. For debug purposes: ${saga.toString()}`
        );
    }

    // 2. Check that we have only unique sagas (one could be from components, another the same one from shared)
    if (injectedSagas[saga.sagaName]) {
        throw new Error(
            `That saga ${saga.sagaName} was already registered. Only 1 instance for particular name is allowed`
        );
    }
    injectedSagas[saga.sagaName] = saga;
}

const productRootSaga = function* productRootSaga() {
    yield all(Object.values(injectedSagas).map((saga) => fork(saga)));
};

productRootSaga.injectedSagas = injectedSagas;

export default productRootSaga;
